import React, { Fragment } from "react";
import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Me5Q.ttf" },
    {
      src: "https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc9.ttf",
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  boldLabel: {
    fontWeight: "bold",
  },
  invoiceNoContainer: {
    flexDirection: "row",
    fontSize: 8.5,
  },
  invoiceDateContainer: {
    flexDirection: "row",
    fontSize: 8.5,
  },
  headerRow: {
    flexDirection: "row",
    backgroundColor: "#263238",
    fontWeight: "bold",
    color: "white",
    fontSize: 8.5,
    marginTop: "10px",
  },
  KOsHeader: {
    fontSize: 8.5,
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    width: "35%",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#263238",
  },
  COsHeader: {
    fontSize: 8.5,
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    width: "35%",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#263238",
  },
  QuoteInfoHeader: {
    fontSize: 8.5,
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    width: "20%",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#263238",
  },
  invoiceDate: {
    fontSize: 8.5,
    fontStyle: "bold",
    textAlign: "right",
  },
  label: {
    width: 60,
    fontSize: 8.5,
    fontWeight: "bold",
    fontFamily: "Roboto",
  },
  Total_Con: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#263238",
  },
  KosHeaderContainer: {
    justifyContent: "flex-start",
    borderColor: "#263238",
    fontSize: 8.5,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    padding: "3px",
    width: "35%",
  },
  Date_Inv_Con: {
    flexDirection: "column",
    borderColor: "#263238",
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    width: "20%",
    borderColor: "#263238",
    padding: "3px",
  },
  QuotedTo: {
    borderColor: "#263238",
    fontSize: 8.5,
    padding: "3px",
    // borderRightWidth:1,
    // borderLeftWidth:1,
    // borderBottomWidth:1,
    width: "35%",
  },
  Quote_label: {
    width: 70,
    fontSize: 8.5,
    fontWeight: "bold",
    fontFamily: "Roboto",
  },
  KOsLabels: {
    width: "70px",
    fontSize: 8.5,
    fontWeight: "bold",
    fontFamily: "Roboto",
  },
  KOsLabelsFlow: {
    flexDirection: "row",
    fontFamily: "Roboto",
  },
  Gap1: {
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    width: "5%",
    backgroundColor: "#fff",
  },
  Gap2: {
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    width: "5%",
    backgroundColor: "#fff",
  },
  EmailColor: {
    color: "#0d47a1",
    textDecoration: "underline",
  },
});

const InvoiceNo = ({ invoice }) => (
  <Fragment>
    <View style={styles.headerRow}>
      {/* <Text style={styles.KOsHeader}>Customer Details</Text>
            <View style={styles.Gap1}>
            </View> */}
      <Text style={styles.COsHeader}>Bill To</Text>
      {/* <View style={styles.Gap1}>
            </View>
            <Text style={styles.QuoteInfoHeader}>Quote Info</Text> */}
    </View>
    <View style={styles.Total_Con}>
      {/* 
    <View style={styles.Gap2}>
    </View> */}

      <View style={styles.QuotedTo}>
        <View style={styles.invoiceNoContainer}>
          <Text style={styles.label}>Name:</Text>
          <Text>{invoice.BillTo_Name ? invoice.BillTo_Name : ""}</Text>
        </View>
        {/* <View style={styles.invoiceNoContainer}>
          <Text style={styles.label}>Address:</Text>
          <Text>{invoice.BillTo_Address ? invoice.BillTo_Address : ""}</Text>
        </View> */}
        <View style={styles.invoiceNoContainer}>
          <Text style={styles.label}>Address:</Text>
          <View style={{ flexDirection: "column", flex: 1 }}>
            {Array.isArray(invoice.BillTo_Address) &&
            invoice.BillTo_Address.length > 0 ? (
              invoice.BillTo_Address.map((line, i) => (
                <Text key={i} style={{ fontSize: 8.5 }}>
                  {line}
                </Text>
              ))
            ) : (
              <Text style={{ fontSize: 8.5 }}>
                {invoice.BillTo_Address ?? ""}
              </Text>
            )}
          </View>
        </View>
        <View style={styles.invoiceNoContainer}>
          <Text style={styles.label}>Email:</Text>
          <Text>{invoice.BillTo_Email ? invoice.BillTo_Email : ""}</Text>
        </View>
        <View style={styles.invoiceNoContainer}>
          <Text style={styles.label}>Phone:</Text>
          <Text>{invoice.BillTo_Phone ? invoice.BillTo_Phone : ""}</Text>
        </View>
      </View>

      <View style={styles.Gap2}></View>
    </View>
  </Fragment>
);

export default InvoiceNo;
